"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = require("../form-definition");
exports.errorTypes = {
    inline: 'inline-error',
    global: 'global-error'
};
function validationError(sourceId, label, section, errorNum, message, errorType) {
    if (errorType === void 0) { errorType = exports.errorTypes.global; }
    var errorId = section + '-' + errorNum;
    return new form_definition_1.Error({
        id: "error-" + sourceId + "-" + errorId,
        sourceId: sourceId,
        type: errorType,
        context: label,
        errorMessage: message
    });
}
exports.validationError = validationError;
;
function sectionedValidationError(sourceId, label, subSection, section, errorNum, message, errorType) {
    if (errorType === void 0) { errorType = exports.errorTypes.global; }
    var baseError = validationError(sourceId, label, section, errorNum, message, errorType);
    return baseError.set('subSection', subSection);
}
exports.sectionedValidationError = sectionedValidationError;
//# sourceMappingURL=validation-error.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/validation/validation-error.js
// module id = 1166
// module chunks = 0